import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/game-center-container.module.scss";
import {GameCenterContainerSideBar} from "./game-center-container.side-bar";
import {ScrollerWrapper} from "../../../core/components/scroll-wrapper/scroll-wrapper";
import {Outlet} from "react-router-dom";
import {useDisplayAdByLayout} from "../../../infrastructure/hooks/useDisplayAdByLayout";
import useAdStatus from "../../../infrastructure/hooks/ads/useAdStatus";

export const GameCenterContainerContent = observer(({controller, scrollToTop}) => {
  const {state, device} = controller;
  const {shouldRenderAd, adConfig} = state;
  const {isSmallView} = device;

  const {shouldDisplayAd} = useDisplayAdByLayout(controller, adConfig?.validLayouts);
  const {isAdFilled} = useAdStatus(adConfig?.adUnit);
  const shouldApplyAdContainer: Boolean = shouldRenderAd && shouldDisplayAd && (isAdFilled || !adConfig?.collapseEmptyDiv);

  const gameProps = {
    scrollToTop
  }

  return <div className={classNames(styles.container, {[styles.small_view]: isSmallView, [styles.ad_container]: shouldApplyAdContainer})}>
    <GameCenterContainerSideBar controller={controller}/>
    <ScrollerWrapper className={classNames(styles.content)}>
      <Outlet context={{...gameProps}}/>
    </ScrollerWrapper>
  </div>
})
